import script from "./equipment.vue?vue&type=script&lang=ts&setup=true"
export * from "./equipment.vue?vue&type=script&lang=ts&setup=true"

import "./equipment.vue?vue&type=style&index=0&id=92171746&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92171746"]])

export default __exports__